import React from "react";
import ChildHeaderCard from "./components/ChildHeaderCard";
import HeaderBack from "./components/HeaderBack";
import ChildHealthProfilePanel from "./components/ChildHealthProfilePanel";

/** Mobile screen with the health profile of one child. */
const ChildHealthView = ({
  t,
  child,
  classroomsByChild,
  pendingChildren = [],
  pendingChildUpdateSet = new Set(),
  onBack,
}) => (
  <div className="pp-family-view mx-auto grid w-full max-w-[33rem] gap-4 pb-6">
    <div className="grid grid-cols-[minmax(0,1fr)_auto] items-start gap-3 px-1 pt-1">
      <HeaderBack label={t("common.back", { defaultValue: "Back" })} onBack={onBack} />
      <ChildHeaderCard
        t={t}
        child={child}
        classroomsByChild={classroomsByChild}
        pendingChildren={pendingChildren}
        pendingChildUpdateSet={pendingChildUpdateSet}
      />
    </div>

    <div className="px-1">
      <h2 className="m-0 text-[1.45rem] font-black leading-tight text-slate-950 dark:text-slate-50">
        {t("parentPortal.health.title", { defaultValue: "Contacts & notes" })}
      </h2>
    </div>

    <div className="rounded-[1.35rem] bg-white p-4 shadow-sm dark:bg-slate-900/80">
      <ChildHealthProfilePanel t={t} childId={child?.id} childName={child?.firstName} />
    </div>
  </div>
);

export default ChildHealthView;
